import {Component} from '@angular/core';
import { GenericService } from '../../services/base/generic-service';
import {MatTableModule} from '@angular/material/table';

export class  BaseMatTable<T> extends MatTableModule {

    test():void{

        
    }
}